// extracted by mini-css-extract-plugin
export default {"closebutton":"CloseButton_closebutton__f01IE"};